import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import FloatLabel from "../../../../../../components/FloatLabel";
import { ErrorMessage, retrieveData, triggerNotification, useGetApiRequests } from "../../../../../../common/CommonExport";

import { useParams } from "react-router-dom";
import './uploadEmployeeDocument.scss'
import ModalLoader from "../../../../../../components/Loader/ModalLoader";

const MissingDocumentNotificationModal = (props: any) => {
  const { id }: any = useParams();
  const employeeDocumentTypes = useGetApiRequests('documentType', 'GET');

  const [open, setOpen] = useState(props?.open || false);
  const [documentType, setDocumentType] = useState<string[]>([]);
  const [documentList, setDocumentList] = useState<any[]>([]);
  const [showError, setShowError] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const token: string = retrieveData('authToken', true);
  const employeeId: any = retrieveData('loggedInEmployeeId', true);
  useEffect(() => {
    setOpen(props?.open);
  }, [props?.open]);

  useEffect(() => {
    employeeDocumentTypes()
      .then((res: any) => {
        setDocumentList(res?.data?.data || []);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }, []);

  const handleClose = () => {
    setOpen(false);
    props?.setMissingNotificationOpen(false);
  };

  const handleChange = (value: any) => {
    setDocumentType(value);
  };

  const handleAddDocument = () => {
    if (documentType.length === 0) {
      setShowError(true);
      return;
    }
    finalSubmit();
  };

  const finalSubmit = async () => {
    setLoader(true);
    const baseUrl = `${process.env.REACT_APP_ELMS_BASEURL}/core/api/v1/hrm/employee/${id}/sendMissingDocuments`;
    const query = documentType.map((item: string) => `documentName=${encodeURIComponent(item)}`).join("&");
    try {
      const url = `${baseUrl}?${query}`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          employeeId: employeeId
        },
        body: JSON.stringify({ documentName: documentType }),
      });

      if (!response.ok) {
        throw new Error("Something went wrong");
      }

      const data = await response.json();

      triggerNotification("success", "", data?.status?.message, "topRight");
      handleClose();
    } catch (err) {
      triggerNotification("error", "", "Something went wrong", "topRight");
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal
      title="Missing Documents"
      centered
      open={open}
      onCancel={handleClose}
      footer={null}
      className="modal-uploadDocument"
      maskClosable={false}
    >
      {loader && <ModalLoader />}
      <div className="py-6 documentUpload upload">
        <div className="form-item select-width">
          <FloatLabel label="Document Type *" name="documentType" value={documentType}>
            <Select
              className="float-control"
              onChange={handleChange}
              showSearch
              allowClear
              mode="multiple"
              filterOption={(input: any, option: any) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}>
              {documentList.map((option: any) => (
                <Select.Option key={option.documentTypeId} value={option.name}>
                  {option.name}
                </Select.Option>
              ))}
            </Select>
          </FloatLabel>
          {showError && documentType.length === 0 && (
            <ErrorMessage message="Please select Document Type" />
          )}
        </div>
        <div className="flex justify-end mt-8">
          <button className="addButton secondary mr-5" onClick={handleClose}>
            Cancel
          </button>
          <button className="addButton" onClick={handleAddDocument}>
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MissingDocumentNotificationModal;
